"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventHttpClient = void 0;
const atlas_engine_sdk_1 = require("@atlas-engine/atlas_engine_sdk");
const index_1 = require("../Types/index");
const BaseClient_1 = require("./BaseClient");
const Mappers_1 = require("./Lib/Mappers");
class EventHttpClient extends BaseClient_1.BaseClient {
    async query(query, identity, offset, limit, sortSettings) {
        const enhancedQuery = {
            ...query,
            eventType: [
                atlas_engine_sdk_1.EventType.messageEvent,
                atlas_engine_sdk_1.EventType.signalEvent,
                atlas_engine_sdk_1.EventType.timerEvent,
            ],
        };
        const url = this.buildUrl(index_1.restSettings.paths.queryFlowNodeInstances, offset, limit, enhancedQuery, sortSettings);
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        const response = await this.httpClient.get(url, requestAuthHeaders);
        const mappedResult = {
            totalCount: response.result.totalCount,
            events: response.result.flowNodeInstances.map(Mappers_1.mapEvent),
        };
        return mappedResult;
    }
    async triggerMessageEvent(messageName, processInstanceId, payload, identity) {
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        let urlRestPart = index_1.restSettings.paths.triggerMessageEvent.replace(index_1.restSettings.params.eventName, messageName);
        if (processInstanceId) {
            urlRestPart = `${urlRestPart}?process_instance_id=${processInstanceId}`;
        }
        const url = this.buildUrl(urlRestPart);
        await this.httpClient.post(url, payload, requestAuthHeaders);
    }
    async triggerSignalEventOnProcessInstance(signalName, processInstanceId, payload, identity) {
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        let urlRestPart = index_1.restSettings.paths.triggerSignalEvent.replace(index_1.restSettings.params.eventName, signalName);
        urlRestPart = `${urlRestPart}?process_instance_id=${processInstanceId}`;
        const url = this.buildUrl(urlRestPart);
        await this.httpClient.post(url, payload, requestAuthHeaders);
    }
    async triggerSignalEvent(signalName, payload, identity) {
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        const urlRestPart = index_1.restSettings.paths.triggerSignalEvent.replace(index_1.restSettings.params.eventName, signalName);
        const url = this.buildUrl(urlRestPart);
        await this.httpClient.post(url, payload, requestAuthHeaders);
    }
    async onBoundaryEventTriggered(callback, subscribeOnce, identity) {
        return this.createSocketIoSubscription(index_1.socketSettings.paths.boundaryEventTriggered, callback, subscribeOnce, identity);
    }
    async onIntermediateThrowEventTriggered(callback, subscribeOnce, identity) {
        return this.createSocketIoSubscription(index_1.socketSettings.paths.intermediateThrowEventTriggered, callback, subscribeOnce, identity);
    }
    async onIntermediateCatchEventReached(callback, subscribeOnce, identity) {
        return this.createSocketIoSubscription(index_1.socketSettings.paths.intermediateCatchEventReached, callback, subscribeOnce, identity);
    }
    async onIntermediateCatchEventFinished(callback, subscribeOnce, identity) {
        return this.createSocketIoSubscription(index_1.socketSettings.paths.intermediateCatchEventFinished, callback, subscribeOnce, identity);
    }
    async removeSubscription(identity, subscription) {
        this.removeSocketIoSubscription(identity, subscription);
    }
}
exports.EventHttpClient = EventHttpClient;
//# sourceMappingURL=EventHttpClient.js.map